import {
  Dealer,
  useGetWorkSpaceDealershipQuery,
} from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";
import get from "lodash/get";

export const useCurrentDealerInfo = (): [Dealer | undefined, boolean] => {
  const currentDealerId = useCurrentDealerId();
  const { data, loading } = useGetWorkSpaceDealershipQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "cache-and-network",
  });
  return [get(data, "WorkSpaceGetter.getDealerShip.dealer"), loading];
};
